import {createSlice, isAnyOf} from '@reduxjs/toolkit'
import {
  createOmsCustomerAsync,
  getOmsCustomerDetailsAsync,
  getOmsCustomersAsync,
  updateOmsCustomerAsync,
} from '../actions/omsCustomerActions'

type OmsCustomerState = {
  listLoading: boolean
  detailLoading: boolean
  saving: boolean
  customerList: any[]
  selectedCustomer: any | null
  pagination: {
    pageNumber: number
    count: number
  }
}

const initialState: OmsCustomerState = {
  listLoading: false,
  detailLoading: false,
  saving: false,
  customerList: [],
  selectedCustomer: null,
  pagination: {
    pageNumber: 1,
    count: 0,
  },
}

const extractCustomerList = (payload: any) => {
  return (
    payload?.results?.data ||
    payload?.data?.results?.data ||
    payload?.data?.data ||
    payload?.results ||
    payload?.data ||
    []
  )
}

const omsCustomerSlice = createSlice({
  name: 'omsCustomerSlice',
  initialState,
  reducers: {
    clearSelectedOmsCustomer: (state) => {
      state.selectedCustomer = null
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getOmsCustomersAsync.pending), (state) => {
      state.listLoading = true
    })

    builder.addMatcher(isAnyOf(getOmsCustomersAsync.rejected), (state) => {
      state.listLoading = false
    })

    builder.addMatcher(isAnyOf(getOmsCustomersAsync.fulfilled), (state, action: any) => {
      state.listLoading = false
      state.customerList = extractCustomerList(action.payload)
      state.pagination.count = action.payload?.count ?? action.payload?.data?.count ?? 0
      state.pagination.pageNumber = action.meta.arg?.page ?? 1
    })

    builder.addMatcher(isAnyOf(getOmsCustomerDetailsAsync.pending), (state) => {
      state.detailLoading = true
    })

    builder.addMatcher(isAnyOf(getOmsCustomerDetailsAsync.rejected), (state) => {
      state.detailLoading = false
    })

    builder.addMatcher(isAnyOf(getOmsCustomerDetailsAsync.fulfilled), (state, action: any) => {
      state.detailLoading = false
      state.selectedCustomer = action.payload?.data || action.payload
    })

    builder.addMatcher(
      isAnyOf(createOmsCustomerAsync.pending, updateOmsCustomerAsync.pending),
      (state) => {
        state.saving = true
      }
    )

    builder.addMatcher(
      isAnyOf(createOmsCustomerAsync.rejected, updateOmsCustomerAsync.rejected),
      (state) => {
        state.saving = false
      }
    )

    builder.addMatcher(
      isAnyOf(createOmsCustomerAsync.fulfilled, updateOmsCustomerAsync.fulfilled),
      (state, action: any) => {
        state.saving = false
        state.selectedCustomer = action.payload?.data || action.payload
      }
    )
  },
})

export const {clearSelectedOmsCustomer} = omsCustomerSlice.actions
export default omsCustomerSlice.reducer
